<template>
<div class="chapter">
<div class="inner_page">
<div id="little-movien">
<div style="text-align:center">
<img alt="" height="100%" src="images/img_04.jpg"/>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// little_05.vue?3ee7f051